import { render } from "./StatedImplants.vue?vue&type=template&id=095832ac&scoped=true"
import script from "./StatedImplants.vue?vue&type=script&lang=js"
export * from "./StatedImplants.vue?vue&type=script&lang=js"

import "./StatedImplants.vue?vue&type=style&index=0&id=095832ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095832ac"]])

export default __exports__